import { useRequiredFieldsQuery } from '@/generated/graphql';
import { computed } from 'vue';

export const useRequiredFields = (module: string) => {
	const { result } = useRequiredFieldsQuery(
		{
			input: {
				module,
			},
		},
		{
			fetchPolicy: 'cache-first',
		}
	);

	const requiredFields = computed(
		() => result.value?.RequiredUniqueFields.requiredFields
	);

	return {
		requiredFields,
	};
};
